export const SPRINT_STATE_ACTIVE = 'ACTIVE' as const;
export const SPRINT_STATE_FUTURE = 'FUTURE' as const;
export const SPRINT_STATE_CLOSED = 'CLOSED' as const;

export const NO_STARTED_SPRINT_AVAILABLE_ERROR_KEY = 'jsw.reports.no-started-sprint-available';
export const NO_SUCH_SPRINT_FOUND_ERROR_KEY = 'jsw.reports.no-such-sprint-found';

export const ANALYTICS_SOURCE = 'burn-reports-common';

export const SPRINT_ACTION_REOPEN = 'sprintActionReopen';
